import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    firstItemOnly,
    INTEGRITY_FAIL_MEDIA,
} from "~utils/moduleIntegrity";

import type { SingleStoryHomepageLedeProps } from "./SingleStoryHomepageLede";

export default function integrityCheck({
    items = [],
    image,
    embedUrl,
    liveStream,
    video,
}: SingleStoryHomepageLedeProps): IntegrityStatus {
    const messages = checkItemArrayIntegrity(firstItemOnly(items));

    // This variation needs some form of multimedia to be valid.
    if (
        !(
            embedUrl ||
            liveStream ||
            image?.baseUrl ||
            items?.[0]?.image?.baseUrl ||
            video
        )
    ) {
        messages.push(INTEGRITY_FAIL_MEDIA);
    }

    return messages;
}
